import { fr, type I18nKey } from './fr';
export type { I18nKey };

/**
 * Les dictionnaires, par langue. Une seule pour l'instant : les énigmes reposent sur des
 * expressions, qui ne se traduisent pas, donc une langue n'arrive qu'avec SES énigmes (cf.
 * README). L'interface, elle, est prête — ajouter une langue, c'est un fichier ici et une entrée
 * dans cette table.
 */
const DICTS: Record<string, Record<I18nKey, string>> = { fr };
export const LANGS = Object.keys(DICTS);

export const lang: string = (() => {
  const want = (navigator.language || 'fr').slice(0, 2).toLowerCase();
  return LANGS.includes(want) ? want : 'fr';
})();

/** Le texte d'une clé, avec ses `{variables}` remplacées. */
export function t(key: I18nKey, vars: Record<string, string | number> = {}): string {
  const s = DICTS[lang][key] ?? fr[key];
  return s.replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? `{${k}}`));
}
